import React from 'react'
import { VirtualBoard } from '../../components/virtualBoard/VirtualBoard'

export const BoardPage = () => {
  return (
    <div className='container'>
        <VirtualBoard />        
    </div>
  )
}
